"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDurationDate = void 0;
const moment_1 = __importDefault(require("moment"));
function getDurationDate(date) {
    const dateDuration = moment_1.default.duration((0, moment_1.default)(date).diff((0, moment_1.default)()));
    var days = parseInt(dateDuration.asDays().toFixed(2));
    var hours = parseInt(dateDuration.asHours().toFixed(2)) - days * 24;
    var minutes = parseInt(dateDuration.asMinutes().toFixed(2)) - (days * 24 * 60 + hours * 60);
    return {
        days,
        hours,
        minutes,
    };
}
exports.getDurationDate = getDurationDate;
